angular.module('unica_notification.notification_services')

.factory('NotificationEditService', function ($http, getBaseApiURL) {

	var notificationEditService = {};

	notificationEditService.update = function (notificationData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/update/' + notificationData.id,
			data: notificationData
		}).then(function(result) {

			if ( result ) {
				return result.data.notificationGroup;
			}

		});
	};

	notificationEditService.updateFilter = function (notificationId, searchData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/update-filter/' + notificationId,
			data: {
				filter: JSON.stringify( searchData )
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.notificationGroup;
			}

		});
	};

	return notificationEditService;
});